import { tv, type VariantProps } from 'tailwind-variants';

export const toolCardV4Variants = tv({
  base: 'gap-6 rounded-lg p-4 shadow-none transition-colors outline-none',
  variants: {
    disabled: {
      true: 'cursor-default bg-muted/40',
      false: [
        'cursor-pointer border-border-light hover:border-border-strong',
        // Same focus treatment as monks-ui v4 buttons — driven by the ring token
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      ].join(' '),
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export type ToolCardV4VariantProps = VariantProps<typeof toolCardV4Variants>;
